const checkStyleIsHidden = (style) => style.getPropertyValue('display') === 'none' ||
                                      style.getPropertyValue('visibility') === 'hidden';

const checkIsHiddenByClass = (className) => {
  let hidden = false;

  if (window && window.document && window.getComputedStyle) {
    const elem = window.document.querySelector(`.${className}`);

    if (elem) {
      hidden = checkStyleIsHidden(window.getComputedStyle(elem));
    }
  }

  return hidden;
};

const checkAdsHidden = () => {
  const result = {
    textAdsHidden: false,
    productAdsHidden: false,
    tourActivityAdsHidden: false,
  };

  // text ads in mainline and sideline both have the same class
  result.textAdsHidden = checkIsHiddenByClass('ad-result');

  // product ads can be a carousel or list (depending on position)
  result.productAdsHidden = checkIsHiddenByClass('product-ads-carousel') || checkIsHiddenByClass('product-ads-list');

  // tours and activities ads are currently sidebar only
  result.tourActivityAdsHidden = checkIsHiddenByClass('tours-activities-ads');

  return result;
};

module.exports = {
  checkIsHiddenByClass,
  checkAdsHidden,
};
